import { useAuthStore } from "@/stores/auth/auth-store";
import { getInMemoryAuthTokens } from "@/stores/auth/token-memory";
import { getStoredUserEmail } from "@/utils";

export const getCurrentAuthTokens = () =>
  getInMemoryAuthTokens();

export const getCurrentAccessToken = (): string | null =>
  getCurrentAuthTokens()?.accessToken ?? null;

export const getCurrentAuthorizationHeader = (): string | null => {
  const accessToken = getCurrentAccessToken();
  return accessToken ? `Bearer ${accessToken}` : null;
};

export const getCurrentAuthHeaders = (): Record<string, string> => {
  const authorization = getCurrentAuthorizationHeader();
  return authorization ? { Authorization: authorization } : {};
};

export const getCurrentUserEmail = (): string | null =>
  useAuthStore.getState().user?.email ?? getStoredUserEmail();
